"use strict";

var _excluded = ["event", "category", "action", "label", "value", "noninteraction"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GtmSupport = void 0;

var assert_is_gtm_id_1 = require("./assert-is-gtm-id");

var utils_1 = require("./utils");
/**
 * The GTM Support main class.
 */


var GtmSupport = /*#__PURE__*/function () {
  /**
   * Constructs a new `GtmSupport` instance.
   *
   * @param options Options.
   */
  function GtmSupport(options) {
    _classCallCheck(this, GtmSupport);

    /**
     * Whether the script is running in a browser or not.
     *
     * You can override this function if you need to.
     *
     * @returns `true` if the script runs in browser context.
     */
    this.isInBrowserContext = function () {
      return typeof window !== 'undefined';
    };

    if (Array.isArray(options.id)) {
      var _iterator = _createForOfIteratorHelper(options.id),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var idOrObject = _step.value;

          if (typeof idOrObject === 'string') {
            (0, assert_is_gtm_id_1.assertIsGtmId)(idOrObject);
          } else {
            (0, assert_is_gtm_id_1.assertIsGtmId)(idOrObject.id);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      (0, assert_is_gtm_id_1.assertIsGtmId)(options.id);
    }

    this.id = options.id;
    this.options = _objectSpread({
      enabled: true,
      debug: false,
      loadScript: true,
      defer: false,
      compatibility: false
    }, options); // @ts-expect-error: Just remove the id from options

    delete this.options.id;
  }
  /**
   * Check if plugin is enabled.
   *
   * @returns `true` if the plugin is enabled, otherwise `false`.
   */


  _createClass(GtmSupport, [{
    key: "enabled",
    value: function enabled() {
      var _a;

      return (_a = this.options.enabled) !== null && _a !== void 0 ? _a : true;
    }
    /**
     * Enable or disable plugin.
     *
     * When enabling with this function, the script will be attached to the `document` if:
     *
     * - the script runs in browser context
     * - the `document` doesn't have the script already attached
     * - the `loadScript` option is set to `true`
     *
     * @param enabled `true` to enable, `false` to disable. Default: `true`.
     */

  }, {
    key: "enable",
    value: function enable() {
      var _this = this;

      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.options.enabled = enabled;

      if (this.isInBrowserContext() && enabled && !(0, utils_1.hasScript)() && this.options.loadScript) {
        if (Array.isArray(this.id)) {
          this.id.forEach(function (id) {
            if (typeof id === 'string') {
              (0, utils_1.loadScript)(id, _objectSpread({}, _this.options));
            } else {
              (0, utils_1.loadScript)(id.id, _objectSpread(_objectSpread({}, _this.options), {}, {
                queryParams: id.queryParams
              }));
            }
          });
        } else {
          (0, utils_1.loadScript)(this.id, _objectSpread({}, this.options));
        }
      }
    }
    /**
     * Check if plugin is in debug mode.
     *
     * @returns `true` if the plugin is in debug mode, otherwise `false`.
     */

  }, {
    key: "debugEnabled",
    value: function debugEnabled() {
      var _a;

      return (_a = this.options.debug) !== null && _a !== void 0 ? _a : false;
    }
    /**
     * Enable or disable debug mode.
     *
     * @param enable `true` to enable, `false` to disable.
     */

  }, {
    key: "debug",
    value: function debug(enable) {
      this.options.debug = enable;
    }
    /**
     * Returns the `window.dataLayer` array if the script is running in browser context and the plugin is enabled,
     * otherwise `false`.
     *
     * @returns The `window.dataLayer` if script is running in browser context and plugin is enabled, otherwise `false`.
     */

  }, {
    key: "dataLayer",
    value: function dataLayer() {
      var _a;

      if (this.isInBrowserContext() && this.options.enabled) {
        return window.dataLayer = (_a = window.dataLayer) !== null && _a !== void 0 ? _a : [];
      }

      return false;
    }
    /**
     * Track a view event with `event: "content-view"`.
     *
     * The event will only be send if the script runs in browser context and the if plugin is enabled.
     *
     * If debug mode is enabled, a "Dispatching TrackView" is logged,
     * regardless of whether the plugin is enabled or the plugin is being executed in browser context.
     *
     * @param screenName Name of the screen passed as `"content-view-name"`.
     * @param path Path passed as `"content-name"`.
     * @param additionalEventData Additional data for the event object. `event`, `"content-name"` and `"content-view-name"` will always be overridden.
     */

  }, {
    key: "trackView",
    value: function trackView(screenName, path) {
      var additionalEventData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _a, _b;

      var trigger = this.isInBrowserContext() && ((_a = this.options.enabled) !== null && _a !== void 0 ? _a : false);

      if (this.options.debug) {
        console.log("[GTM-Support".concat(trigger ? '' : '(disabled)', "]: Dispatching TrackView"), {
          screenName: screenName,
          path: path
        });
      }

      if (trigger) {
        var dataLayer = window.dataLayer = (_b = window.dataLayer) !== null && _b !== void 0 ? _b : [];
        dataLayer.push(_objectSpread(_objectSpread({}, additionalEventData), {}, {
          event: 'content-view',
          'content-name': path,
          'content-view-name': screenName
        }));
      }
    }
    /**
     * Track an event.
     *
     * The event will only be send if the script runs in browser context and the if plugin is enabled.
     *
     * If debug mode is enabled, a "Dispatching event" is logged,
     * regardless of whether the plugin is enabled or the plugin is being executed in browser context.
     *
     * @param param0 Object that will be used for configuring the event object passed to GTM.
     * @param param0.event `event`, default to `"interaction"` when pushed to `window.dataLayer`.
     * @param param0.category Optional `category`, passed as `target`.
     * @param param0.action Optional `action`, passed as `action`.
     * @param param0.label Optional `label`, passed as `"target-properties"`.
     * @param param0.value Optional `value`, passed as `value`.
     * @param param0.noninteraction Optional `noninteraction`, passed as `"interaction-type"`.
     */

  }, {
    key: "trackEvent",
    value: function trackEvent() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref.event,
          _ref$category = _ref.category,
          category = _ref$category === void 0 ? null : _ref$category,
          _ref$action = _ref.action,
          action = _ref$action === void 0 ? null : _ref$action,
          _ref$label = _ref.label,
          label = _ref$label === void 0 ? null : _ref$label,
          _ref$value = _ref.value,
          value = _ref$value === void 0 ? null : _ref$value,
          _ref$noninteraction = _ref.noninteraction,
          noninteraction = _ref$noninteraction === void 0 ? false : _ref$noninteraction,
          rest = _objectWithoutProperties(_ref, _excluded);

      var _a, _b;

      var trigger = this.isInBrowserContext() && ((_a = this.options.enabled) !== null && _a !== void 0 ? _a : false);

      if (this.options.debug) {
        console.log("[GTM-Support".concat(trigger ? '' : '(disabled)', "]: Dispatching event"), _objectSpread({
          event: event,
          category: category,
          action: action,
          label: label,
          value: value
        }, rest));
      }

      if (trigger) {
        var dataLayer = window.dataLayer = (_b = window.dataLayer) !== null && _b !== void 0 ? _b : [];
        dataLayer.push(_objectSpread({
          event: event !== null && event !== void 0 ? event : 'interaction',
          target: category,
          action: action,
          'target-properties': label,
          value: value,
          'interaction-type': noninteraction
        }, rest));
      }
    }
  }]);

  return GtmSupport;
}();

exports.GtmSupport = GtmSupport;